import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { UserAssignmentType } from "@core/enums/user-assignment-type.enum";
import { UserAssignmentNavigationService } from "@core/services/user-assignment-navigation.service";

export const CatalogueAssignmentGuard: CanActivateFn = () =>
  inject(UserAssignmentNavigationService).canActivateAssignment$(UserAssignmentType.COURSES);

export const LearningPathsAssignmentGuard: CanActivateFn = () =>
  inject(UserAssignmentNavigationService).canActivateAssignment$(UserAssignmentType.LEARNING_ROUTE);
